import React from 'react'
import { Route, BrowserRouter } from 'react-router-dom'

import { Main } from './pages/Main/'
import { Confirmation } from './pages/Confirmation'
import { ProductRelease } from './pages/ProductRelease'

const Routes = () => (
  <BrowserRouter>
    <Route exact path='/confirmacao/dados' component={Confirmation} />
    <Route exact path='/liberacao/produto' component={ProductRelease} />
    <Route exact path='/:pin?' component={Main} />
  </BrowserRouter>
)

export default Routes
